import axios from "axios";

export const getCallStatusOptions = (id) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/call-center/get-options/${id}`)
    .then((response) => response.data)
    .catch((e) => Promise.resolve(e));
};

export const getCallStatusStateOptions = () => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/call-center/get-state-options`)
    .then((response) => response.data)
    .catch((e) => Promise.resolve(e));
};